import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import PowerIcon from '@material-ui/icons/PowerSettingsNew'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InsightsIcon from '@material-ui/core/ListItemIcon';
import { Dashboard, Fastfood, FormatListNumbered, Home, NaturePeople, Receipt, Settings, ShoppingBasket, Storage, Storefront, Widgets, AttachMoney, Http } from '@material-ui/icons';
import { Link, useHistory } from 'react-router-dom';
import logo from '../../assets/logo_sicredi.png'
import api from '../../config/api'
import { useAuth } from '../../contexts/auth'

import './styles.css'
import { LinearProgress } from '@material-ui/core';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9) + 1,
            },
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',

            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        title: {
            fontWeight: 800,
            color: '#64C832'
        }
    }),
);

export default function MiniDrawer({ children }: any) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [location, setLocation] = useState('')
    const history = useHistory()
    const [loading, setLoading] = useState(false)


    const [openStateAdmin, setOpenStateAdmin] = useState(false)
    const [openStateStore, setOpenStateStore] = useState(false)
    const [openStateAgro, setOpenStateAgro] = useState(false)

    const [storePermission, setStorePermission] = useState(false)
    const [adminPermission, setAdminPermission] = useState(false)
    const [agroPermission, setAgroPermission] = useState(false)

    const { user, signOut, scopes } = useAuth()


    useEffect(() => {
        async function fetch() {
            setLoading(true)
            if (scopes.find(scope => scope.description === 'Sicredi Store')) {
                setStorePermission(true)
            }
            if (scopes.find(scope => scope.description === 'Admin')) {
                setAdminPermission(true)
            }
            if (scopes.find(scope => scope.description === 'Produção Rural')) {
                setAgroPermission(true)
            }
            setLoading(false)
        }
        fetch()
    }, [scopes])

    function handleSignOut() {
        signOut()
    }

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        getLocation()
    }, [])

    function getLocation() {
        setLocation(String(history.location.pathname))
    }

    return (
        <div className={classes.root} onClick={getLocation}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}

                            edge="start"
                            className={clsx(classes.menuButton, {
                                [classes.hide]: open,
                            })}
                        >
                            <MenuIcon style={{ color: '#fff' }} />
                        </IconButton>
                        <img src={logo} height={50} style={{
                            backgroundColor: '#fff',
                            padding: 10,
                            borderTopLeftRadius: 5,
                            borderBottomLeftRadius: 5
                        }} />
                        <Typography variant="h6" className={classes.title} noWrap
                            style={
                                {
                                    backgroundColor: '#fff',
                                    height: 50,
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderTopRightRadius: 5,
                                    paddingRight: 5,
                                    borderBottomRightRadius: 5,

                                }
                            }>
                            ADMIN
                        </Typography>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: 60,

                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Typography variant="h6" className={classes.title} noWrap
                            style={{
                                backgroundColor: '#FFF',
                                borderRadius: 5,
                                height: 50,
                                paddingLeft: 20,
                                paddingRight: 20,
                                display: 'flex',
                                alignItems: 'center',
                                userSelect: 'none'
                            }}
                        >
                            {
                                //@ts-ignore
                                user ? user.name : ''
                            }
                        </Typography>
                        <button
                            className="power-icon-container"
                            onClick={handleSignOut}
                        >
                            <PowerIcon
                                className="power-icon"
                            />
                        </button>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                {
                    loading ?
                        <LinearProgress color="secondary" style={{ rotate: '90deg', flex: 1 }} />
                        :
                        <>
                            {
                                adminPermission &&
                                <List style={{ margin: 0, padding: 0 }} >
                                    <ListItem style={{ backgroundColor: '#757575' }} onClick={() => { setOpenStateAdmin(!openStateAdmin) }}>
                                        <ListItemIcon className="icon-rotate"  >
                                            <Home style={{ color: '#FFF' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Geral" style={{ color: '#FFF' }} />
                                    </ListItem>
                                    <Divider />
                                    {
                                        openStateAdmin &&
                                        <>
                                            <Link to='/' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon> <Dashboard style={{ color: location === '/' ? '#64C832' : '' }} /></ListItemIcon>
                                                    <ListItemText primary="Dashboards" />
                                                </ListItem>
                                            </Link>
                                            <Link to='/settings' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon> <Settings style={{ color: location.includes('/settings') ? '#64C832' : '' }} /></ListItemIcon>
                                                    <ListItemText primary="Configurações" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                </List>
                            }
                            <Divider />
                            {
                                storePermission &&
                                <List style={{ margin: 0, padding: 0 }}>
                                    <ListItem style={{ backgroundColor: '#757575' }} onClick={() => { setOpenStateStore(!openStateStore) }}>
                                        <ListItemIcon className="icon-rotate" >
                                            <Storefront style={{ color: '#FFF' }} />
                                        </ListItemIcon>
                                        <ListItemText primary="Sicredi Store" style={{ color: '#FFF' }} />
                                    </ListItem>
                                    {
                                        openStateStore &&
                                        <>
                                            <Link to='/orders' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon> <Receipt style={{ color: location.includes('/orders') ? '#64C832' : '' }} /> </ListItemIcon>
                                                    <ListItemText primary="Vendas" />
                                                </ListItem>
                                            </Link>
                                            <Link to='/products' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon> <ShoppingBasket style={{ color: location.includes('/products') ? '#64C832' : '' }} /> </ListItemIcon>
                                                    <ListItemText primary="Produtos" />
                                                </ListItem>
                                            </Link>
                                            <Link to='/stocks' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon>  <Storage style={{ color: location.includes('/stocks') ? '#64C832' : '' }} /> </ListItemIcon>
                                                    <ListItemText primary="Estoques " />
                                                </ListItem>
                                            </Link>
                                            <Link to='/result' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon>  <AttachMoney style={{ color: location.includes('/stocks') ? '#64C832' : '' }} /> </ListItemIcon>
                                                    <ListItemText primary="Resultado Atual" />
                                                </ListItem>
                                            </Link>
                                            <Link to='/links' style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                                <ListItem button>
                                                    <ListItemIcon>  <Http style={{ color: location.includes('/links') ? '#64C832' : '' }} /> </ListItemIcon>
                                                    <ListItemText primary="Links" />
                                                </ListItem>
                                            </Link>
                                        </>
                                    }
                                </List>
                            }

                            <Divider />
                            <Divider />
                        </>
                }


            </Drawer>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {
                    children
                }
            </main>
        </div >
    );
}